import Vue from 'vue';
import Api from '@/config/api';

export default {
  state: {
    // profile: {
    //   full_name: '',
    //   last_name: '',
    //   furigana: '',
    //   last_furigana: '',
    //   email: '',
    //   birth_date: '',
    //   residence: '',
    //   final_education: '',
    //   graduation_school_name: '',
    //   graduation_department_name: '',
    //   year_of_graduation: '',
    //   recent_registered_company_name: '',
    //   // years_of_attendance: '',
    //   latest_occupation_main_title: '',
    //   latest_occupation_sub_title: '',
    //   employment_status: '',
    //   position: '',
    //   english_skills: '',
    //   last_year_income: '',
    //   number_of_experience_companies: '',
    //   job_summary: '',
    //   // phone: '',
    //   resume:'',
    //   file_name:'',
    //   selectedFile:'',
    //   events:[],
    //   cv:'',
    //   cv_file_name:'',
    //   cv_selectedFile:'',
    //   currently_enrolled: undefined,
    //   enrollment_period_from: "/",
    //   enrollment_period_to: "/",
    // },
    profile: {},
    companies: [],
    selectBoxValues: [],
    allEvents: [],
    isProfileLoaded: false,
    // priorityCompanies: [],
  },
  getters: {
    getProfile(state) {
      return state.profile;
    },
    getAllEvents(state) {
      return state.allEvents;
    },
    // getPriorityCompanies(state) {
    //   return state.priorityCompanies;
    // },
    getCompanies(state) {
      return state.companies;
    },
    getSelectBoxValues(state) {
      return state.selectBoxValues;
    },
    getIsProfileLoaded(state) {
      return state.isProfileLoaded;
    },
  },
  mutations: {
    setProfile(state, data) {
      // eslint-disable-next-line
      state.profile = data;
    },
    setAllEvents(state, data) {
      state.allEvents = data;
    },
    setIsProfileLoaded(state, data) {
      state.isProfileLoaded = data;
    },
    // setPriorityCompanies(state, data) {
    //   state.priorityCompanies = data;
    // },
    setCompanies(state, data) {
      state.companies = data;
    },
    setSelectBoxItems(state, data) {
      state.selectBoxValues = data;
    },
    changeEmail(state, data) {
      const newEmail = data;
      state.profile.email = newEmail;
    },
    clearAll(state) {
      state.profile = {};
      state.companies = [],
      state.selectBoxValues = [],
      state.allEvents = []
      // state.priorityCompanies = [];
    },
  },
  actions: {
    async setProfile({ commit }) {
      await Vue.auth.getToken();
      try {
        const profile = await Vue.axios({
          method: 'get',
          url: Api.url(Api.endpoints.profile),
        });
        commit('setProfile', profile.data.data);
        commit('setIsProfileLoaded', true);
      } catch (error) {
        console.log(error);
        Vue.auth.logout();
      }
    },
    async setAllEvents({ commit }) {
      await Vue.auth.getToken();
      try {
        const events = await Vue.axios({
          method: 'get',
          url: Api.url(`${Api.endpoints.events}`),
        });
        commit('setAllEvents', events.data);
      } catch (err) {
        console.log(err);
      }
    },
    // async loadPriorityCompanies({ commit }) {
    //   const token = await Vue.auth.getToken();
    //   try {
    //     const companies = await Vue.axios({
    //       method: 'get',
    //       url: Api.url(`${Api.endpoints.priorityCompanies}`),
    //       headers: {
    //         Authorization: `Bearer ${token}`,
    //       },
    //     });
    //     const priorityCompanies = companies.data.map(company => company._id);
    //     commit('setPriorityCompanies', priorityCompanies);
    //   } catch (err) {
    //     console.log(err);
    //   }
    // },
    async companiesList({ commit }) {
      await Vue.auth.getToken();
      try {
        const response = await Vue.axios({
          method: 'get',
          url: Api.url(`${Api.endpoints.companies}`),
        });
        commit('setCompanies', response.data.data.companies);
      } catch (err) {
        console.log(err);
      }
    },
    async selectBoxValues({ commit }) {
      await Vue.auth.getToken();
      try {
        const response = await Vue.axios({
          method: 'get',
          url: Api.url(`${Api.endpoints.selectBoxValues}`),
        });
        commit('setSelectBoxItems', response.data.data);
      } catch (err) {
        console.log(err);
      }
    },
  },
};
